<!-- main form to enter banking details of customer -->

<!-- loader-->
<div *ngIf="loading">
  <div class="loading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</div>
<!-- end of loader-->
<div *ngIf="!loading" style="padding: 2% 10%;">
  <ng-container *ngIf="role === 'CUSTOMER'">
    <form [formGroup]="bankingDetails" (ngSubmit)="onSubmit()" >
      <h1 style="font-weight: bold; background-color: rgb(30, 0, 85); color:white; text-align: center;">Enter Bank Details</h1>
      <!-- GST-->
      <div class="form-row">
        <div id="left">
          <label>
            <h2>GST Number</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="gstNumber">
          <br>
          <mat-error *ngIf="bankingDetails.controls['gstNumber'].invalid && bankingDetails.controls['gstNumber'].errors.required"> GST Number Required </mat-error>
          <mat-error *ngIf="bankingDetails.controls['gstNumber'].invalid && (bankingDetails.controls['gstNumber'].errors.minlength || bankingDetails.controls['gstNumber'].errors.maxlength)"> Length should be 15 </mat-error>
        </div>
      </div>
      <br>
      <!-- PAN -->
      <div class="form-row">
        <div id="left">
          <label>
            <h2>PAN</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="PAN">
          <br>
          <mat-error *ngIf="bankingDetails.controls['PAN'].invalid && bankingDetails.controls['PAN'].errors.required"> PAN Required </mat-error>
          <mat-error *ngIf="bankingDetails.controls['PAN'].invalid && (bankingDetails.controls['PAN'].errors.minlength || bankingDetails.controls['PAN'].errors.maxlength)"> Length should be 10 </mat-error>
        </div>
      </div>
      <br>
      <!-- CURRENCY -->
      <div class="form-row">
        <div id="left">
          <label>
            <h2>Currency</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="currency">
          <br>
          <mat-error *ngIf="bankingDetails.controls['currency'].invalid && bankingDetails.controls['currency'].errors.required"> Currency Required </mat-error>
        </div>
      </div>
      <br>
      <!-- BANK NAME -->
      <div class="form-row">
        <div id="left">
          <label>
            <h2>Bank Name</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="bankName">
          <br>
          <mat-error *ngIf="bankingDetails.controls['bankName'].invalid && bankingDetails.controls['bankName'].errors.required"> Bank Name Required </mat-error>
        </div>
      </div>
      <br>
      <!-- BANK ACCOUNT NUMBER -->
      <div class="form-row">
        <div id="left">
          <label>
            <h2>Bank Account Number</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="bankAccountNumber">
          <br>
          <mat-error *ngIf="bankingDetails.controls['bankAccountNumber'].invalid && bankingDetails.controls['bankAccountNumber'].errors.required"> Bank Account Required </mat-error>
        </div>
      </div>
      <br>
      <!-- IFSC -->
      <div class="form-row">
        <div id="left">
          <label>
            <h2>IFSC</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="IFSC">
          <br>
          <mat-error *ngIf="bankingDetails.controls['IFSC'].invalid && bankingDetails.controls['IFSC'].errors.required"> IFSC Required </mat-error>
          <mat-error *ngIf="bankingDetails.controls['IFSC'].invalid && (bankingDetails.controls['IFSC'].errors.minlength || bankingDetails.controls['IFSC'].errors.maxlength)"> Length should be 11 </mat-error>
        </div>
      </div>
      <br>
      <!-- SWIFT -->
      <div class="form-row">
        <div id="left">
          <label>
            <h2>SWIFT</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="SWIFT">
          <br>
          <mat-error *ngIf="bankingDetails.controls['SWIFT'].invalid && bankingDetails.controls['SWIFT'].errors.required"> SWIFT Required </mat-error>
          <mat-error *ngIf="bankingDetails.controls['SWIFT'].invalid && (bankingDetails.controls['SWIFT'].errors.minlength || bankingDetails.controls['SWIFT'].errors.maxlength)"> Length should be 11 </mat-error>
        </div>
      </div>
      <br>
      <button type="submit" [disabled]="bankingDetails.invalid" class="btn">SUBMIT</button>

    </form>
  </ng-container>
</div>
<!-- end of form to collect bank details-->